import React, {useState} from "react";
import {Row} from "antd";
import {useFetch} from "../../../hooks/useFetch";
import stores from "../../../store/stores";
import Filters from "./filters/Filters";

import ResponsiveDataTable from "./responsiveDataTable/ResponsiveDataTable";
import ActionButtons from "./actionButtons/ActionButtons";

const PoolShiftManagement = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [filters, setFilters] = useState({
        city: "all"
    });

    const [loading, poolShiftStats] = useFetch({
        fetchFn: stores.poolShiftStore.getAllPoolShifts.bind(null, {
            limit: 5,
            page: currentPage
        }),
        dependencies: [filters, currentPage]
    });

    return (
        <div>
            {/*     <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </Row> */}
            {/*    <Row justify="end">
                <ActionButtons />
            </Row> */}
            <Row>
                <ResponsiveDataTable
                    loading={loading}
                    data={poolShiftStats?.data?.poolList || []}
                    dynamicColumns={poolShiftStats?.data?.dateList || []}
                    dataCount={poolShiftStats?.data?.totalItems || 0}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            </Row>
        </div>
    );
};

export default PoolShiftManagement;
